<template>
  <base-modal
    size="lg"
    class="base-filter-table-display"
    modalId="preview"
    is-scrollable
    @hide="emit('on-close-filter')"
    hideHeader
    hideFooter
    :is-modal-open="isOpenFilter"
  >
    <template #modal-header>
      <div class="header-name">
        <span>{{ t('component.filter_table.title') }}</span>
      </div>
    </template>
    <template #modal-action>
      <div class="d-flex align-items-center header-close ms-auto">
        <span @click="emit('on-close-filter')">x</span>
      </div>
    </template>
    <template #modal-body>
      <div class="filter-container">
        <div class="ordering-body">
          <div class="ordering-inner">
            <div class="topic-ordering mb-2">
              <span>{{ t('component.filter_table.topic_sorting') }}</span>
            </div>
            <ordering
              :is-open-sorting="isOpenFilter"
              :select-current-value="selectedColumn.key"
              :select-sorting="selectColumnSorting"
              @on-select-ordering="onSelectOrdering"
              @on-force-close-sort="$emit('on-force-close-sort', $event)"
            />
          </div>
        </div>
        <div class="filter-body">
          <div class="filter-select-display mb-3">
            <div class="topic-filter">
              <span>{{ t('component.filter_table.topic_filter') }}</span>
            </div>
            <div class="subtopic-filter mt-2">
              <span>{{ t('component.filter_table.column') }}</span>
            </div>
            <div class="select-container">
              <select-column
                id-column="id_column"
                label="column_alias"
                :is-selected="isOpenFilter"
                :options="optionOperator"
                :select-value="selectColumn"
                :placeholder="$i18n.locale == 'en-US' ? '- select -' : '- เลือก -'"
                @on-selected="selectedOperatorAndLoadOperator"
              />
            </div>
          </div>
          <div class="filter-display">
            <div class="form-display-inner">
              <form @submit.prevent="onSetFilterTable" class="select-oparetor-group">
                <div class="d-flex align-items-center justify-content-start oparetor-group-inner">
                  <select-operator
                    class="me-2"
                    label="description"
                    id-operator="operatorId"
                    :placeholder="$i18n.locale == 'en-US' ? '- Operator -' : '- ตัวจัดการ -'"
                    :options="selectedColumn.operation_list"
                    :select-value="selectedOperator"
                    @on-selected="onSelectOperetorList"
                  />
                  <div
                    v-if="showContent('rule-value-1-input-1', selectedOperator.value)"
                    class="d-flex align-items-center justify-content-center show-box"
                  >
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$i18n.locale == 'en-US' ? '- specify -' : '- ระบุ -'"
                      :value="ruleValue01"
                      @input="(event) => (ruleValue01 = (event.target as HTMLInputElement).value)"
                      required
                    />
                  </div>
                  <div
                    v-if="showContent('rule-value-1-input-2', selectedOperator.value)"
                    class="d-flex align-items-center justify-content-center show-box"
                  >
                    <input
                      type="number"
                      placeholder="0"
                      :value="ruleValue01"
                      @input="(event) => (ruleValue01 = (event.target as HTMLInputElement).value)"
                      class="form-control"
                      required
                    />
                  </div>
                  <div
                    v-if="showContent('rule-value-1-datetime', selectedOperator.value)"
                    class="d-flex align-items-center justify-content-center show-box"
                  >
                    <choco-date-picker class="custom-date-picker" :timezone="timezone" v-model="ruleValue01" />
                    <choco-time-picker class="custom-date-picker" :timezone="timezone" v-model="ruleValue01" />
                  </div>
                  <div
                    v-if="showContent('rule-value-1-date', selectedOperator.value)"
                    class="d-flex align-items-center justify-content-center show-box"
                  >
                    <choco-date-picker class="custom-date-picker" :timezone="timezone" v-model="ruleValue01" />
                  </div>
                  <div
                    v-if="showContent('rule-value-1-time', selectedOperator.value)"
                    class="d-flex align-items-center justify-content-center show-box"
                  >
                    <choco-time-picker class="custom-date-picker" :timezone="timezone" v-model="ruleValue01" />
                  </div>
                  <div
                    v-if="showContent('rule-value-2-input-1', selectedOperator.value)"
                    class="d-flex align-items-center justify-content-center show-box"
                  >
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$i18n.locale == 'en-US' ? '- specify -' : '- ระบุ -'"
                      :value="ruleValue02"
                      @input="(event) => (ruleValue02 = (event.target as HTMLInputElement).value)"
                      required
                    />
                  </div>
                  <div
                    v-if="showContent('rule-value-2-datetime', selectedOperator.value)"
                    class="d-flex align-items-center justify-content-center show-box"
                  >
                    <choco-date-picker class="custom-date-picker" :timezone="timezone" v-model="ruleValue02" />
                    <choco-time-picker class="custom-date-picker" :timezone="timezone" v-model="ruleValue02" />
                  </div>
                  <div
                    v-if="showContent('rule-value-2-date', selectedOperator.value)"
                    class="d-flex align-items-center justify-content-center show-box"
                  >
                    <choco-date-picker class="custom-date-picker" :timezone="timezone" v-model="ruleValue02" />
                  </div>
                  <div v-if="showContent('rule-unit', selectedOperator.value)" class="d-flex align-items-center justify-content-center show-box">
                    <select-operator
                      :placeholder="$i18n.locale == 'en-US' ? '- Unit -' : '- หน่วย -'"
                      :options="selectedOperator.unit_list"
                      :select-value="selectedUnit"
                      label="description"
                      id-operator="unitId"
                      @on-selected="onSelectOperatorUnit"
                    />
                  </div>
                  <div v-if="selectedOperator.value" class="action-form">
                    <button type="submit" class="btn btn-action-form">
                      <search-icon class="search-icon" />
                    </button>
                  </div>
                </div>
              </form>
              <div v-if="isLoading" class="form-empty text-center">
                <loader-spinner />
              </div>
              <div v-else-if="!isLoading && dataColumnResult.length == 0" class="form-empty text-center">
                <filter-empty-icon class="filter-empty-icon mb-2" />
                <div class="topic"><span>No Filter</span></div>
              </div>
              <div v-else class="form-list position-relative" ref="listGroupRef">
                <div class="form-group-checkbox checked-all-container" :class="{ itemBlur: isLoadingInResult }">
                  <input type="checkbox" class="checkbox-form" id="all" @change="onSelectAllRow" ref="AllGroupRef" checked />
                  <label for="all">{{ t('component.filter_table.all_item') }}</label>
                </div>
                <div class="checked-list-container" @scroll="onScrolled" :class="{ itemBlur: isLoadingInResult }">
                  <div v-for="(item, index) in dataColumnResult" :key="index" class="form-group-checkbox">
                    <input
                      type="checkbox"
                      class="checkbox-form"
                      :class="convertClassInList(item[selectedColumn.key])"
                      :id="`checked-item-${index}`"
                      @change="onSelectRow($event, item)"
                      checked
                    />
                    <label :for="`checked-item-${index}`">{{ onConvertItem(String(item[selectedColumn.key])) }}</label>
                  </div>
                </div>
                <transition name="fade">
                  <div class="loading-result" v-if="isLoadingInResult">
                    <loader-spinner />
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="preview-container position-relative">
        <div class="topic-preview">
          <span>{{ t('component.filter_table.topic_preview') }}</span>
        </div>
        <div class="preview-section-inner mt-2">
          <preview-select-column
            :previewTableId="tableId ?? 0"
            :data-preview-table="selectColumnFilter"
            @on-remove-item="emit('on-remove-item', $event)"
          />
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="btn-action-container" style="display: contents">
        <button class="btn btn-clear" @click="onClearFilter" :disabled="selectColumnFilter.length == 0">
          {{ t('component.filter_table.button_clear') }}
        </button>
        <button class="btn btn-apply" @click="onApplyFilter" :disabled="isLoadingInResult || isLoading">
          {{ t('component.filter_table.button_apply') }}
        </button>
      </div>
    </template>
  </base-modal>
</template>

<script setup lang="ts">
import { ChocoDatePicker, ChocoTimePicker } from '@choco-platform/components';
import { useI18n } from 'vue-i18n';

import Ordering from './components/Ordering.vue';
import SelectColumn from './components/SelectColumn.vue';
import SelectOperator from './components/SelectOperator.vue';
import SearchIcon from '@/assets/icons/base/table/Search.vue';
import BaseModal from '@/views/components/modal/BaseModal.vue';
import PreviewSelectColumn from './components/PreviewSelectColumn.vue';
import FilterEmptyIcon from '@/assets/icons/base/table/FilterEmpty.vue';
import LoaderSpinner from '@/views/components/loader/loader-spinner.vue';

import useBaseFilterTable from './hooks/useBaseFilterTable';

const { t } = useI18n();

interface Props {
  isOpenFilter: boolean;
  tableColumn: Array<BaseTable.TableColumn>;
  selectColumn: FilterTable.DisplayColumns;
  selectColumnFilter: any;
  selectColumnSorting: any;
  tableId?: number;
}

const props = defineProps<Props>();

const emit = defineEmits([
  'on-close-filter',
  'force-close-filter',
  'on-selected-all',
  'on-data-filter',
  'on-remove-item',
  'on-clear-data-filter',
  'on-selected-sorting',
  'on-force-close-sort',
]);

const {
  optionOperator,
  selectedOperator,
  selectedColumn,
  timezone,
  dataColumnResult,
  isLoading,
  ruleValue01,
  ruleValue02,
  listGroupRef,
  AllGroupRef,
  isLoadingInResult,
  isSelectedAll,
  selectedUnit,
  onSelectOperatorUnit,
  onClearFilter,
  convertClassInList,
  onConvertItem,
  onScrolled,
  onSelectAllRow,
  onSelectRow,
  onApplyFilter,
  onSetFilterTable,
  onSelectOrdering,
  selectedOperatorAndLoadOperator,
  onSelectOperetorList,
  showContent,
} = useBaseFilterTable(props);
</script>

<style lang="scss" scoped>
@import '@/assets/styles/base/filter-table/base-table-filter.scss';
</style>
